import { Stmttrn } from "./Stmttrn";

export class Trnlist{
    constructor(){}
    // Stmttrn: Stmttrn[] = null;
    Stmttrn: Stmttrn = null;

    Deserialize(input:any){
        // if (input!=null){
        //     this.Stmttrn=[];
        //     this.Stmttrn.push(new Stmttrn().Deserialize(input));
            
        // }
        this.Stmttrn = new Stmttrn().Deserialize(input);
        return this;

    }
   
}